import styled from "styled-components";

export const Palg3Wrap = styled.div`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const Header = styled.div`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 25px;
  line-height: 28px;
  /* identical to box height, or 112% */
  display: flex;
  align-items: center;

  /* Текст/#333333 текст|кнопки */
  color: #333333;
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;
export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const WrapSelect = styled.div`
  display: flex;
  align-self: flex-end;
`;
